<template lang="html">
  <div class="detail-view" v-if="model != null">


    <!-- BANNER -->
    <div class="vergelijk_knop " style="right: 0px; top: 80px;" v-if="">
      <label class="custom-checkbox mb-0 font-weight-bold" >
        <input :value="type" :key="type.nTypeID" :checked="isChecked(type)"   @change="handleCheckboxChange(type)" type="checkbox" >

        <span class="checkmark "></span>
        Vergelijk
      </label>
    </div>

    <Banner :type="type" :panorama="mobilePanorama ?? panorama" class="d-block d-sm-none"/>

    <!-- Displayed on sm screens (576px and up) -->
    <Banner :type="type" :panorama="panorama" class="d-none d-sm-block"/>


    <!--END  BANNER -->
    <div class="d-none container cartype-selection">
      <div class="row">
        <div class="col-md-6">
          <div class="breadcrumbs">
            <nuxt-link to="/elektrische-auto">
              <i class="mdi mdi-home"></i>
              <h4>Alle elektrische auto's</h4>
            </nuxt-link>
          </div>
        </div>
        <div class="col-md-6">
        </div>
      </div>
    </div>

    <!-- FEATURES -->
    <Intro :type="type" :model="model"/>
    <!-- END FEATURES -->
    <!-- Image Swiper -->
    <CarImageGallery :typeID="type.nTypeIDHist" :type="type"/>
    <!-- END Image Swiper -->

    <!-- EV Data -->
    <div id="accuInfo" class="p30 container">
      <h4><span class="mouseover">EV gegevens</span></h4>
      <h2>Accu en Laadgegevens</h2>
      <div class="row">
        <ul class="col-md-6">
          <li><span>Accucapaciteit</span> <strong>{{Math.round(type.Accu_capaciteit_kWh)}} kWh</strong></li>
          <li><span>Kabel</span> <strong>TYPE {{type.Type_oplaadkabel}}</strong></li>
          <li><span>Laadvermogen</span> <strong>{{type.Ruwe_waarde_laadv}} kW</strong></li>
          <li><span>Laadtijd</span> <strong><span v-if="String(type.nLaadtijd).split('.')[0] > 0">{{String(type.nLaadtijd).split('.')[0]}} uur en</span>
            {{formatTime(type.nLaadtijd)}} minuten</strong></li>
          <li class="border-none"><span>Laadsnelheid</span> <strong>{{Math.round(type.nLaadsnelheid)}} km/u</strong>
          </li>
        </ul>
        <ul class="col-md-6">
          <li><strong>{{type.nIngeschatteBruikbareAccucapaciteit}} kWh</strong><span>Geschatte accucapaciteit</span>
          </li>
          <li><span>Snellaadkabel</span> <strong>{{fastLoaders[type.cSnellaadkabel]}}</strong></li>
          <li><span>Snel laadvermogen</span> <strong>{{type.nSnellaadvermogen}} kW</strong></li>
          <li>
            <span>Snel laadtijd</span>
            <strong>
              <span v-if="String(type.nSnellaadtijd).split('.')[0] > 0">{{String(type.nSnellaadtijd).split('.')[0]}} uur en</span>
              {{formatTime(type.nSnellaadtijd)}} minuten
            </strong>
          </li>
          <li class="border-none"><span>Snel laadsnelheid</span> <strong>{{Math.round(type.nSnellaadSnelheid)}}
            km/u</strong></li>
        </ul>
      </div>
    </div>

    <!-- END EV Data -->
    <cta-button :url="getRouteCarTCO(model, 'vergelijk/autokosten')" locname="under-specs"/>
    <!-- Specifications -->
    <Specs :type="type"/>
    <!-- END Specifications -->
    <!-- Zomer & Winter -->
    <div class="specifications p30" id="actieradius">
      <!-- <img src="@/assets/pattern.png" alt="WhatTheRange"> -->
      <h2 class="text-center">Actieradius en Verbruik</h2>
      <div class="container p30">

        <div class="row">
          <div class="col-md-5">
            <div class="container info-text">
              <div class="template-demo">
                <h2 class="text-center zomer" style="color:#f1c40f;">Zomer</h2>
                <p>Een elektrische auto kan verder rijden in de zomer dan in de winter. Hieronder een indicatie van de
                  {{type.cMerknaam}} {{type.cModelnaam}} {{type.cTypenaam_1}} in de zomer.</p>
                <table class="table mb-0">
                  <tbody>
                  <tr>
                    <td class="pl-0"></td>
                    <td class="pr-0 text-right">
                      Actieradius
                    </td>
                    <td class="pr-0 text-right">
                      Verbruik
                    </td>
                  </tr>
                  <tr>
                    <td class="pl-0">Stad</td>
                    <td class="pr-0 text-right">
                      <strong>{{Math.round(type.nActieradiusStadZomer)}} km</strong>
                    </td>
                    <td class="pr-0 text-right">
                      <strong>{{type.nVerbruikStadZomer}} kWh</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="pl-0">Snelweg</td>
                    <td class="pr-0 text-right">
                      <strong>{{Math.round(type.nActieradiusSnelwegZomer)}} km</strong>
                    </td>
                    <td class="pr-0 text-right">
                      <strong>{{type.nVerbruikSnelwegZomer}} kWh</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="pl-0">Gecombineerd</td>
                    <td class="pr-0 text-right">
                      <strong>{{Math.round(type.nActieradiusGecombineerdZomer)}} km</strong>
                    </td>
                    <td class="pr-0 text-right">
                      <strong>{{type.nVerbruikGecombineerdZomer}} kWh</strong>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-md-2">
          </div>
          <div class="col-md-5">
            <div class="container info-text">
              <div class="template-demo">
                <h2 class="text-center" style="color:#3498db">Winter</h2>
                <p>Een elektrische auto kan minder ver rijden in de winter dan in de zomer. Hieronder een indicatie van
                  de {{type.cMerknaam}} {{type.cModelnaam}} {{type.cTypenaam_1}} in de winter.</p>
                <table class="table mb-0">
                  <tbody>
                  <tr>
                    <td class="pl-0"></td>
                    <td class="pr-0 text-right">
                      Actieradius
                    </td>
                    <td class="pr-0 text-right">
                      Verbruik
                    </td>
                  </tr>
                  <tr>
                    <td class="pl-0">Stad</td>
                    <td class="pr-0 text-right">
                      <strong>{{Math.round(type.nActieradiusStadWinter)}} km</strong>
                    </td>
                    <td class="pr-0 text-right">
                      <strong>{{type.nVerbruikStadWinter}} kWh</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="pl-0">Snelweg</td>
                    <td class="pr-0 text-right">
                      <strong>{{Math.round(type.nActieradiusSnelwegWinter)}} km</strong>
                    </td>
                    <td class="pr-0 text-right">
                      <strong>{{type.nVerbruikSnelwegWinter}} kWh</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="pl-0">Gecombineerd</td>
                    <td class="pr-0 text-right">
                      <strong>{{Math.round(type.nActieradiusGecombineerdWinter)}} km</strong>
                    </td>
                    <td class="pr-0 text-right">
                      <strong>{{type.nVerbruikGecombineerdWinter}} kWh</strong>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Zomer & Winter -->
    <transition name="slide-up">
      <div v-if="selectedCars && selectedCars.length > 0" class="compare-card">
        <comparing-card @update="selectedCar = null" :selected-cars="selectedCars" />
      </div>
    </transition>

    <!-- ROB Restwaarde -->
    <Restwaarde v-if="restwaarde" :type="type" :restwaarde="restwaarde"/>
    <!-- END Rob Restwaarde -->

    <cta-button :url="getRouteCarTCO(model, 'vergelijk/autokosten')" locname="under-restwaarde"/>

    <!-- OPTIONS -->
    <Options :typeID="type.nTypeIDHist" :model="model" :type="type"/>
    <!-- END OPTIONS -->

    <!-- disclaimer-->
    <ContentBlok :id="'disclaimer_praktijk'"  :backgroundColor="'#2ecc71'" :textColor="'#ffffff'" :setStyle="'text-align:center;scroll-margin-top: 50px;'" :title="`Hoe bereken wij het praktijkverbruik?`" :text="`Het praktijkverbruik van ${type.cMerknaam}   ${type.cModelnaam} ${type.cTypenaam_1} ${type.cTypenaam_2} op Whattherange is berekend aan de hand van analyse van laadpasdata.  Deze gegevens zijn verzameld over een langere periode, waarbij het werkelijke aantal geladen kilowatturen is opgeteld en gedeeld door de afgelegde afstand. <br/> Het energiegebruik omvat in deze berekening ook de laadverliezen. Dit is van belang omdat deze kilowatturen daadwerkelijk worden verbruikt en moeten worden opgewekt. Het display van de auto houdt geen rekening met deze verliezen bij het tonen van het energieverbruik in kWh/100 km of Wh/km.`" />

    <autoReview v-if="news && news.length > 0"/>

    <!-- Segment Cars -->
    <SegmentCars :model="model" :segmentCars="segmentCars"/>
    <!-- END Segment Cars -->
  </div>
</template>

<script>

import Banner from '@/components/Banner'
import Intro from '@/components/Intro'
import CarModelText from '@/components/CarModelText'
import CarImageGallery from '@/components/CarImageGallery'
import Specs from '@/components/Specs'
import Restwaarde from '@/components/Restwaarde'
import Options from '@/components/Options'
import autoReview from '@/components/autoreview'
import Autoreview from '@/components/autoreview'
import CtaButton from '@/components/CtaButton'

import SegmentCars from '@/components/SegmentCars'
import ContentBlok from '@/components/ContentBlok.vue';
import ComparingCard from "@/components/comparingCard.vue";

export default {
    name: 'specificaties',
    components: {
      ComparingCard,
      Autoreview,
      Banner,
      CtaButton,
      Restwaarde,
      Intro,
      CarImageGallery,
      Specs,
      CarModelText,
      Options,
      SegmentCars,
      ContentBlok,
      autoReview,
    },
    data() {
      return {
        fastLoaders: {
          ccs: 'CCS Combo 2',
          ccs2: 'CCS Combo 2',
          type2: 'Mennekes',
          cdm: 'CHAdeMO',
          2: 'Type 2',
          1: 'Type 1',
          sc: 'Tesla Supercharger'
        },
        selectedCars: [],
        selectedCar: false
      }
    },

    computed:{
      news() {
        return this.$store.state.news
      },

    },


    mounted() {
      if (typeof sessionStorage !== 'undefined' && JSON.parse(sessionStorage.getItem('selectedCars'))) {
        const selectedCars = JSON.parse(sessionStorage.getItem('selectedCars'));
        this.selectedCars = selectedCars
        const model = parseInt(this.$route.params.model) // Get the model ID from route parameters
        this.selectedCar = selectedCars.find(car => car.nModelID === model)
      }


      this.$store.dispatch('getNews', this.$route.params.model)

      this.$gtag('event', 'screen_view', {
        'app_name': 'whattherange',
        'screen_name' : 'Model Overview',
      });
      this.$gtag('event', `mounted`, {
        event_category: 'Model Overview',
        event_label: this.$route.params.brand,
        value: this.$route.params.model,
      });
    },
    /**
     * Async SSR
     */
    async asyncData({app, params, redirect}) {
      const model = await app.$axios.$get('/api/ModelViewv2/' + params.model)

      // check for results
      if (model.length === 0)
        return redirect('/')

      var type = null;
      if (params.type != undefined) {
        for (let i in model[0]['Modellen'][0].motor)
          if ((model[0]['Modellen'][0].motor[i].typeinformation[0].cTypenaam_1.replace(/\s+/g, '-') + '-' + model[0]['Modellen'][0].motor[i].typeinformation[0].cTypenaam_2.replace(/\s+/g, '-')) == params.type)
            type = model[0]['Modellen'][0].motor[i].typeinformation[0];
      } else {
        type = model[0]['Modellen'][0].motor[0].typeinformation[0]
      }
      if (type === null)
        type = model[0]['Modellen'][0].motor[0].typeinformation[0]


      let [restwaarde, panorama, mobilePanorama, segmentCars] = await Promise.all([
        app.$axios.$get('/api/ROB/' + type.nTypeIDHist + ';' + type.njaar + '').then((restwaarde)=>{return restwaarde}).catch(err=>{
          return false
        }),
        app.$axios.$get('/api-car/getModelAfbeeldingen/nTypeID=' + type.nTypeIDHist + ';cClient=30abad7b-0b3f-452d-ab65-20c7db9520e8;nFotoWidth=1800;cFotoRatio=4-1'),
        app.$axios.$get('/api-car/getModelAfbeeldingen/nTypeID=' + type.nTypeIDHist + ';cClient=30abad7b-0b3f-452d-ab65-20c7db9520e8;nFotoWidth=900;cFotoRatio=16-9'),
        app.$axios.$get('/api/ModelViewv2/segement/' + type.cSegmentAdvanced.toLowerCase() + ';' + type.nModelID + ';' + true),
      ])
      return {
        cMerknaam: model[0]['cMerknaam'],
        model: model[0]['Modellen'][0],
        type: type,
        restwaarde: (restwaarde === false) ? false : restwaarde[0],
        panorama: panorama.getModelAfbeeldingenResult[0],
        mobilePanorama: mobilePanorama.getModelAfbeeldingenResult.find(image => image.cFotonaam === "x.jpg"),

        segmentCars: segmentCars
      }
    },

    /**
     * Update head
     */
    head() {
      var seoModel = this.type.cMerknaam + '-' + this.type.cModelnaam.replace(/\s+/g, '-');
      var seoType = this.type.cTypenaam_1.replace(/\s+/g, '-') + '-' + this.type.cTypenaam_2.replace(/\s+/g, '-')

      return {
        title: `${this.cMerknaam} ${this.type.cModelnaam} met ${Math.round(this.type.nIngeschatteActieradius)} km actieradius | WhatTheRange`,
        meta: [
          {
            hid: 'title',
            name: 'title',
            content: `${this.cMerknaam} ${this.type.cModelnaam} met ${Math.round(this.type.nIngeschatteActieradius)} km actieradius | WhatTheRange`
          },
          {
            hid: 'og:title',
            property: 'og:title',
            content: `${this.cMerknaam} ${this.type.cModelnaam} met ${Math.round(this.type.nIngeschatteActieradius)} km actieradius | WhatTheRange`
          },
          {
            hid: 'description',
            name: 'description',
            content: `De volledige elektrische ${this.cMerknaam} ${this.type.cModelnaam} ${this.type.cTypenaam_1}. Bekijk het verbruik, de actieradius, elektrische specificaties, auto opties, verwachtte restwaarde en onderhoud.`
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: `De volledige elektrische ${this.cMerknaam} ${this.type.cModelnaam} ${this.type.cTypenaam_1}. Bekijk het verbruik, de actieradius, elektrische specificaties, auto opties, verwachtte restwaarde en onderhoud.`
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: `${this.cMerknaam}, ${this.type.cModelnaam}, ${this.type.cTypenaam_1}, ${this.type.WLTPsoort}, Elektrische auto, Auto, Actieradius, Verbruik, Restwaarde, Onderhoud, Auto opties, Autogegevens, WhatTheRange`
          },
          {
            hid: 'og:keywords',
            property: 'og:keywords',
            content: `${this.cMerknaam}, ${this.type.cModelnaam}, ${this.type.cTypenaam_1}, ${this.type.WLTPsoort}, Elektrische auto, Auto, Actieradius, Verbruik, Restwaarde, Onderhoud, Auto opties, Autogegevens, WhatTheRange`
          },
          {
            hid: 'og:url',
            property: 'og:url',
            content: `https://www.whattherange.com/elektrische-auto/${this.type.nModelID}/${seoModel}/${seoType}`
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: `https://media.autodisk.nl/fotos/geel/${this.type.nModelID}/16-9/1200/a.jpg`
          },
          {
            hid: 'og:image:secure_url',
            property: 'og:image:secure_url',
            content: `https://media.autodisk.nl/fotos/geel/${this.type.nModelID}/16-9/1200/a.jpg`
          },
          {hid: 'og:image:width', property: 'og:image:width', content: `1200`},
          {hid: 'og:image:height', property: 'og:image:height', content: `675`},
          {
            hid: 'og:image:alt',
            property: 'og:image:alt',
            content: `${this.cMerknaam} ${this.type.cModelnaam} met ${Math.round(this.type.nIngeschatteActieradius)} km actieradius | WhatTheRange`
          },
          {
            hid: 'url',
            name: 'url',
            content: `https://www.whattherange.com/elektrische-auto/${this.type.nModelID}/${seoModel}/${seoType}`
          },
          {hid: 'language', name: 'language', content: 'NL'},
          {hid: 'og:site_name', property: 'og:site_name', content: `WhatTheRange`},
          {hid: 'og:locale', property: 'og:locale', content: `nl_NL`},
          {hid: 'author', name: 'author', content: 'WhatTheRange'}
        ]
      }
    },

    methods: {
      isChecked(type) {
        return this.selectedCars.some(car => car.nTypeID === type.nTypeID);
      },
      handleCheckboxChange(type) {
        console.log(type)
        console.log(this.selectedCars)

        // Find the index of the type in the selectedCars array
        const index = this.selectedCars.findIndex(car => car.nTypeID === type.nTypeID);
        // console.log(index)

        if (index !== -1) {
          console.log('exist')
          // If the model exists in the array, remove it
          this.selectedCars.splice(index, 1);
          sessionStorage.setItem('selectedCars', JSON.stringify(this.selectedCars));

          this.selectedCar = null
        } else if (this.selectedCars.length < 3) {
          console.log('existNot')

          // If the model does not exist and the array length is less than 3, add the model
          this.selectedCars.push(type);
          sessionStorage.setItem('selectedCars', JSON.stringify(this.selectedCars));

        }
      },




      formatTime(time) {
        return Math.round(parseFloat(0 + '.' + String(time).split('.')[1]) * 60)
      },
      getRouteCarTCO(model, prefix) {
        const seoModel = model.cMerknaam + '-' + model.cModelnaam.replace(/\s+/g, '-') + '-' + this.type.cTypenaam_1.replace(/\s+/g, '-') + '-' + this.type.cTypenaam_2.replace(/\s+/g, '-');
        const id = this.type.nTypeIDHist
        return '/' + prefix + '/' + id + '/' + seoModel;
      },
    }

  }
</script>


<style media="screen" lang="scss">


  .pt-30 {
    padding-top: 30px;
  }

  .detail-view {
    margin-top: -2px;
  }

  #accuInfo {
    background: #fff;
    z-index: 30;
    position: relative;

    ul {
      li {
        display: block;
        border-bottom: 1px solid #f3f3f3;
        line-height: 40px;
        padding: 10px;

        strong {
          display: inline-block;
          text-align: right;
          color: #2ecc71;
          font-weight: 600;
          font-family: Poppins, sans-serif;
          float: right;
        }

        span {
          display: inline-block;
          font-weight: 600;
          color: #232323 !important;
          font-family: Poppins, sans-serif;
        }
      }
    }
  }

.compare-card {
  position: fixed;
  z-index: 1000;
  bottom: 0px;
  margin: 0 auto;
  right: 0;
  left: 0;
  width: 800px;
}


@media (max-width: 1024px) {
  .compare-card{
    position: fixed;
    z-index: 10000;
    bottom: 0px;
    //transform: translateX(-50%) ;
    width: 100% !important;

  }
}

.slide-up-enter-active, .slide-up-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.slide-up-enter-to, .slide-up-leave {
  transform: translateY(0);
  opacity: 1;
}

</style>
